import { EditPencil } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const EditIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <EditPencil width={size} height={size} color={color} {...rest} />;

export default EditIcon;
